import { c as _c } from "react/compiler-runtime";
import React from "react";
import WaveWinnersDropHeaderTotalVotes from "./WaveWinnersDropHeaderTotalVotes";
import WaveWinnersDropHeaderVoters from "./WaveWinnersDropHeaderVoters";
import WaveWinnersDropHeaderAuthorHandle from "./WaveWinnersDropHeaderAuthorHandle";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
interface WaveWinnersDropHeaderProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly showVotingInfo?: boolean | undefined;
}
export const WaveWinnersDropHeader: React.FC<WaveWinnersDropHeaderProps> = t0 => {
  const $ = _c(22);
  const {
    winner,
    showVotingInfo: t1
  } = t0;
  const showVotingInfo = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== winner) {
    t2 = <WaveWinnersDropHeaderAuthorHandle winner={winner} />;
    $[0] = winner;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `winner-author-badges-${winner.drop.id}`;
  let t4;
  if ($[2] !== t3 || $[3] !== winner.drop.author) {
    t4 = <DropAuthorBadges profile={winner.drop.author} tooltipIdPrefix={t3} />;
    $[2] = t3;
    $[3] = winner.drop.author;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = winner.drop.winning_context?.decision_time ?? null;
  let t6;
  if ($[5] !== t5 || $[6] !== winner.place) {
    t6 = <WinnerDropBadge rank={winner.place} decisionTime={t5} />;
    $[5] = t5;
    $[6] = winner.place;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-600" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== winner.drop.created_at) {
    t8 = <WaveDropTime timestamp={winner.drop.created_at} />;
    $[9] = winner.drop.created_at;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t6 || $[14] !== t8) {
    t9 = <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1 xl:tw-w-auto">{t2}{t4}{t6}{t7}{t8}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== showVotingInfo || $[17] !== winner) {
    t10 = showVotingInfo && <div className="tw-mt-1 tw-whitespace-nowrap sm:tw-mt-0"><div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-2 sm:tw-gap-x-4 xl:tw-flex-nowrap"><WaveWinnersDropHeaderTotalVotes winner={winner} /><WaveWinnersDropHeaderVoters winner={winner} /></div></div>;
    $[16] = showVotingInfo;
    $[17] = winner;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div onClick={_temp} className="tw-flex tw-w-full tw-flex-wrap tw-justify-between tw-gap-y-2 xl:tw-flex-nowrap">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
function _temp(e) {
  return e.stopPropagation();
}